/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Posts_Description_PlaceholderInputs */

const en_admin_posts_description_placeholder = /** @type {(inputs: Admin_Posts_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brief description`)
};

const zh_admin_posts_description_placeholder = /** @type {(inputs: Admin_Posts_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`简短描述`)
};

/**
* | output |
* | --- |
* | "Brief description" |
*
* @param {Admin_Posts_Description_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_posts_description_placeholder = /** @type {((inputs?: Admin_Posts_Description_PlaceholderInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Posts_Description_PlaceholderInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_posts_description_placeholder(inputs)
	return zh_admin_posts_description_placeholder(inputs)
});
export { admin_posts_description_placeholder as "admin.posts.description_placeholder" }